import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';
import { TestimonialProvider } from './context/TestimonialContext';
import { AuthProvider } from './context/AuthContext';
import AppShell from './components/layout/AppShell';
import DashboardLayout from './components/layout/DashboardLayout';
import ProtectedRoute from './components/layout/ProtectedRoute';
import SuperAdminRoute from './components/layout/SuperAdminRoute';
import DomainEnforcer from './components/layout/DomainEnforcer';

import Landing from './pages/Landing/Landing';
import LifetimeDeal from './pages/Landing/LifetimeDeal';
import Privacy from './pages/Legal/Privacy';
import Terms from './pages/Legal/Terms';
import Auth from './pages/Auth/Auth';

import SEO from './pages/Dashboard/SEO';
import Connect from './pages/Dashboard/Connect';
import Reviews from './pages/Dashboard/Reviews';
import WidgetBuilder from './pages/Dashboard/WidgetBuilder';
import Settings from './pages/Dashboard/Settings';
import MyPage from './pages/Dashboard/MyPage';

import Reports from './pages/Dashboard/Superadmin/Reports';
import Users from './pages/Dashboard/Superadmin/Users';

import WidgetEmbed from './pages/Embed/WidgetEmbed';
import PublicProfile from './pages/Public/PublicProfile';

// Component to handle /ref/:code route and instantly redirect
const RefHandler = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      localStorage.setItem('mot_ref', code);
    }
    navigate('/', { replace: true });
  }, [code, navigate]);

  return null;
};

function App() {
  // Global check for ?ref=parameter on any incoming request
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      localStorage.setItem('mot_ref', ref);
    }
  }, []);

  return (
    <AuthProvider>
      <TestimonialProvider>
        <BrowserRouter>
          <DomainEnforcer>
            <Routes>
              {/* Referral Route */}
              <Route path="/ref/:code" element={<RefHandler />} />

              {/* Public Routes with Top Navbar */}
              <Route element={<AppShell />}>
                <Route path="/" element={<Landing />} />
                <Route path="/ltd" element={<LifetimeDeal />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
              </Route>

              {/* Auth Route */}
              <Route path="/auth" element={<Auth />} />

              {/* Standalone Route for Public Profile (Wall of Love) */}
              <Route path="/p/:username" element={<PublicProfile />} />

              {/* Standalone Embed Route (No Header/Sidebar) */}
              <Route path="/embed/:widgetId" element={<WidgetEmbed />} />

              {/* Dashboard Routes with Sidebar (Protected) */}
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<DashboardLayout />}>
                  <Route index element={<Navigate to="reviews" replace />} />
                  <Route path="reviews" element={<Reviews />} />
                  <Route path="my-page" element={<MyPage />} />
                  <Route path="widgets" element={<WidgetBuilder />} />
                  <Route path="seo" element={<SEO />} />
                  <Route path="connect" element={<Connect />} />
                  <Route path="settings" element={<Settings />} />

                  {/* Superadmin Routes */}
                  <Route element={<SuperAdminRoute />}>
                    <Route path="reports" element={<Reports />} />
                    <Route path="users" element={<Users />} />
                  </Route>
                </Route>
              </Route>
            </Routes>
          </DomainEnforcer>
        </BrowserRouter>
      </TestimonialProvider>
    </AuthProvider>
  );
}

export default App;